<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">{{ state.updatedId ? 'Редактировать статус' : 'Создать статус' }}</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="page__row mb-40">
          <AppInput title="Полное наименование"
                    name="contractorName"
                    :value="state.name"
                    :valid="state.validation.name"
                    @value-changed="setItemName"
                    @keyup-enter="saveItemInfo"
                    @got-focus="clearValidation('name')"
          />
        </div>
        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton :title="state.updatedId == null ? 'Создать' : 'Сохранить' " type="main" @click.native="saveItemInfo"/>
          </div>
          <div class="modal__button">
            <AppButton title="Отмена" type="alt" @click.native="closeModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/page/button/AppButton.vue'
import AppInput from '@/components/page/input/AppInput'

export default {
  name: 'contractor-status-modal',
  components: {
    AppInput,
    AppButton
  },
  props: {
    state: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  methods: {
    setItemName (value) {
      this.$emit('set-item-name', value)
    },
    saveItemInfo () {
      this.$emit('save-item-info')
    },
    clearValidation (inputName) {
      this.$emit('clear-validation', inputName)
    },
    closeModal () {
      this.$emit('close-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../../assets/css/system/_vars';
    @import '../../assets/css/system/_mixins';

    .modal {
      max-width: 500px;

      &__text {
        text-align: center;
        color: $font_color_second;
        margin-bottom: 20px;
      }

      &__button-wrap {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
      }

      &__button {
        margin-right: 16px;
        margin-bottom: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
</style>
